<template>
    <div>
        <date-picker
            v-model="fieldData.start_date.tempStartDate"
            :months="months"
            :weekdays="weekdays"
            :class="[fieldData.start_date.hasError ? 'errorinput' : '', 'datepicker']"
            :show-week-number="true"
            valueType="format"
            :disabled-date="isDateDisabled"
            :clearable="false"
            :lang="enSv"
        ></date-picker>
        <label class="text-danger" v-if="fieldData.start_date.errorMsg.length > 0">{{ fieldData.start_date.errorMsg }}</label>
    </div>
</template>

<script>
import DatePicker from "vue2-datepicker"
import "vue2-datepicker/index.css"
import "vue2-datepicker/locale/en"
import computedVal from "@/mixins/computedVal"
import props from "@/mixins/inputProps"
import propsDate from "@/mixins/inputPropsDate"
import datePickerConfig from "@/mixins/datePickerConfig"
import { isDateNotBetweenTwoDates, dateToyymmddFormat } from "../../../../api/utils.js"
import dayjs from "dayjs"
import globalConfig from "../../../../mixins/globalConfig"
import sv from 'vue2-datepicker/locale/sv'

export default {
    name: "DateFromChannels",
    components: {
        DatePicker,
    },
    mixins: [computedVal, props, propsDate, globalConfig, datePickerConfig],
    computed: {
        enSv() {
            sv.formatLocale.monthsShort = this.monthsShort
            return {
                ...sv,
                days: [...this.weekdays],
                months: [...this.months],
            }
        },
        isDateValidFormat() {
            return dayjs(this.fieldData.start_date.tempStartDate, "YYYY-MM-DD").format("YYYY-MM-DD") === this.fieldData.start_date.tempStartDate
        },
    },
    async mounted() {
        await this.loadGlobalConfigFromFile()
        require("dayjs/locale/sv")
        dayjs.locale("sv")
        if (this.fieldData.start_date.tempStartDate) this.checkIfError(this.fieldData.start_date.tempStartDate)
    },
    methods: {
        isDateDisabled(datepickerDate) {
            let fromDate = new Date(this.fieldData.start_date.datePeriod.fromDate)
            let toDate = new Date(this.fieldData.start_date.datePeriod.endDate)
            let disableDate = false
            let selectedGroupTimeId = this.fieldData.grouptime.tempGroupTime.id
            if (selectedGroupTimeId === "sevendays") {
                var isBetween = require("dayjs/plugin/isBetween")
                dayjs.extend(isBetween)
                let sevenDaysBeforeLastToDate = dayjs(toDate).subtract(6, "d")
                let dateIsLessThanSevenDaysFromToDate = dayjs(dateToyymmddFormat(datepickerDate)).isBetween(sevenDaysBeforeLastToDate, toDate, "d")
                if (dateIsLessThanSevenDaysFromToDate || dayjs(dateToyymmddFormat(datepickerDate)).isSame(toDate, "d") || isDateNotBetweenTwoDates(datepickerDate, fromDate, toDate)) disableDate = true
            } else if (selectedGroupTimeId === "week") {
                let isDateLaterThanToDate = dayjs(dateToyymmddFormat(datepickerDate))
                    .add(7, "d")
                    .isAfter(dayjs(dateToyymmddFormat(toDate)))
                let datepickerDateDayjsObj = dayjs(dateToyymmddFormat(datepickerDate))
                //if datepickerDate is not monday or datepickerdate is not between todate and enddate disable date
                if (datepickerDateDayjsObj.get("d") !== 1 || isDateNotBetweenTwoDates(datepickerDate, fromDate, toDate) || isDateLaterThanToDate) disableDate = true
            } else {
                if (isDateNotBetweenTwoDates(datepickerDate, fromDate, toDate)) disableDate = true
            }
            let toV3ChangeDate = new Date(this.config_ToV3ChangeDate)
            toV3ChangeDate.setHours(0, 0, 0)
            if (datepickerDate < toV3ChangeDate) disableDate = true
            return disableDate
        },
        checkIfError(chosendate) {
            this.fieldData.hasError = false
            this.fieldData.errorMsg = ""
            if ((this.isDateDisabled(new Date(chosendate)) && this.fieldData.required) || !this.isDateValidFormat) {
                this.fieldData.hasError = true
                this.fieldData.errorMsg = "Viewing data is missing for the selected date or the date is in the wrong format"
            }
        },
    },
    watch: {
        "fieldData.tempStartDate"(chosendate) {
            this.checkIfError(chosendate)
        },
    },
}
</script>
<style scoped>
input {
    height: 30px !important;
    box-sizing: border-box;
    border: 1px solid #ced4da;
    padding: 2px 5px !important;
}
</style>
